import React from 'react';

var Content = function Content(props) {
  var overlay = props.overlay,
      prefixCls = props.prefixCls,
      id = props.id;
  return React.createElement("div", {
    className: "".concat(prefixCls, "-inner"),
    id: id,
    role: "tooltip"
  }, typeof overlay === 'function' ? overlay() : overlay);
};

export default Content;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-tooltip@4.0.3@rc-tooltip/es/Content.js
// module id = 2301
// module chunks = 0